import { render, staticRenderFns } from "./BaseFab.vue?vue&type=template&id=00d44db3&scoped=true&"
import script from "./BaseFab.vue?vue&type=script&lang=js&"
export * from "./BaseFab.vue?vue&type=script&lang=js&"
import style0 from "./BaseFab.vue?vue&type=style&index=0&id=00d44db3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d44db3",
  null
  
)

export default component.exports